// extracted by mini-css-extract-plugin
export default {"background_div":"Propertey_background_div__5zZT9","label":"Propertey_label__MNEBC"};